import { render } from "./KnowledgePage.vue?vue&type=template&id=26cf82c8&scoped=true"
import script from "./KnowledgePage.vue?vue&type=script&lang=js"
export * from "./KnowledgePage.vue?vue&type=script&lang=js"

import "./KnowledgePage.vue?vue&type=style&index=0&id=26cf82c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cf82c8"]])

export default __exports__